module.exports = __webpack_public_path__ + "static/media/ZEREPORTES.f48f699b.png";